import './MainPageSub02.scss';
import fig_search from '../images/home/logo_trans.png'; 
import React, { useEffect } from 'react';
import 'aos/dist/aos.css';
import AOS from 'aos';

const MainPageSub02 = () => {
    useEffect(() => {
        AOS.init({
            duration: 1500,
            easing: 'ease-in-out',
        });
    
    }, []);
    
    //=============================================================
    return (
        <div className="MainPageSub02">
            <section className='sec-main'>

                <p className="heading-1 title1">
                    02 <span className="i-custom">진로를 열다.</span>
                </p>

                <section className='sec-sub1'>

                {/* 첫 번째 섹션 - 목표강도와 공부력 관계 */}
                <article className='art-main'>

                    {/* 제목 - 위에서 내려오는 애니메이션 */}
                    <p className="heading-3 title2" data-aos="fade-down" data-aos-duration="1000">
                        목표강도에 따라 공부력은 달라진다!!
                    </p>

                    {/* 설명 - 확대되면서 등장 */}
                    <section className="description" data-aos="zoom-in" data-aos-delay="300">
                        <p>
                            <mark>적성</mark>과 <mark>진로</mark>의 결정과 확정여부에 따라 <mark>공부력</mark>을 좌우하는 
                            <mark>[집중력과 몰입능력]</mark>의 차이
                            즉, 학업수준과 학습격차의 결정적인 원인이 됩니다. <br />얼마나 다양한 활동을 하고 있느냐와 
                            얼마나 빠르게 찾아내느냐 하는 것은 시간과 비용뿐만 아니라 쏟아 부은 열정과 에너지의 
                            총량으로 결정되지만 이는 시행착오의 총량으로도 비례하게 됩니다.
                        </p>
                    </section>

                    {/* 두 번째 제목 - 위에서 내려오는 애니메이션 */}
                    <p className="heading-3 title2" data-aos="fade-down" data-aos-delay="600">
                        그래서, 진로부터 찾아내고 결정해야 합니다!
                    </p>

                    {/* 분석 리스트 - 하나씩 순차적으로 등장 */}
                    <ul className="analysis-list">
                        <li data-aos="fade-right" data-aos-delay="800">
                            유형별 <mark>진로방향</mark>을 명확하게 유추하여 시행착오를 줄일 수 있습니다.
                        </li>
                        <li data-aos="fade-right" data-aos-delay="1000">
                            유형별 <mark>진로결정/확정</mark>을 위한 <mark>맞춤 미션</mark>을 제공합니다.
                        </li>
                        <li data-aos="fade-right" data-aos-delay="1200">
                            유형별 진로결정은 <mark>고교학점제 대비</mark>에 필수입니다.
                        </li>
                        <li data-aos="fade-right" data-aos-delay="1400">
                            유형별 진로확정은 <mark>강력한 목표력</mark>과 <mark>공부력</mark>을 만들어 줍니다.
                        </li>
                    </ul>
                </article>

                {/* 이미지 - 오른쪽에서 등장 */}
                <article className='art-main' data-aos="fade-left" data-aos-delay="1500">
                    <img className='img-abcd' src={fig_search} alt="유형 분석 이미지" />
                </article>

                </section>


            </section>
        </div>
    );
};

export default MainPageSub02;
